import { useContext, useEffect, useState } from "react";

export const useShippingPendingHeader = (props) => {
    return {};
};
